import {Component, Directive, EventEmitter, Input, Output, inject} from '@angular/core';
import {FavoriteSource, FavoriteType, FavoritesService} from '../../../favorites/favorites.service';
import {FavoriteState} from '../../../favorites/favorite-state';
import {buildInventoryMenu} from '../../context-menu/inventory-menu';
import {SmContextMenuItemModel} from '../sm-context-menu-item/sm-context-menu-item.component';
import {SmContextMenuModule} from '../sm-context-menu/sm-context-menu.module';
import type {SmContextMenuTriggerVariant} from '../sm-context-menu/sm-context-menu.component';

export type InventoryMenuOptions = {canEdit: boolean; source: FavoriteSource};

/** Shared rendering and state logic; concrete components fix the entity type. */
@Directive()
export abstract class InventoryContextMenuBase {
  private readonly favorites = inject(FavoritesService);
  @Input({required: true}) entity!: FavoriteState & {id: string};
  abstract readonly entityType: FavoriteType;
  @Input({required: true}) options!: InventoryMenuOptions;
  @Input() triggerAriaLabel = '';
  @Input() triggerVariant: SmContextMenuTriggerVariant = 'plain';
  @Output() itemSelect = new EventEmitter<SmContextMenuItemModel>();

  get items(): SmContextMenuItemModel[] {
    return buildInventoryMenu(this.entityType,
      this.favorites.menu(this.entityType, this.entity.id, this.entity.isFavorite), this.options.canEdit);
  }

  select(item: SmContextMenuItemModel): void {
    if (item.disabled) return;
    if (item.id === 'favorite') {
      if (this.entity.isFavorite !== undefined) {
        void this.favorites.set(this.entityType, this.entity.id, !this.entity.isFavorite, this.options.source);
      }
      return;
    }
    if (this.options.canEdit || (this.entityType === 'item' && item.id === 'add-to-basket')) this.itemSelect.emit(item);
  }
}

@Component({
  selector: 'sm-container-context-menu', standalone: true, imports: [SmContextMenuModule],
  templateUrl: './sm-inventory-context-menu.component.html', styleUrl: './sm-inventory-context-menu.component.scss',
})
export class SmContainerContextMenuComponent extends InventoryContextMenuBase {
  readonly entityType = 'container' as const;
}

@Component({
  selector: 'sm-item-context-menu', standalone: true, imports: [SmContextMenuModule],
  templateUrl: './sm-inventory-context-menu.component.html', styleUrl: './sm-inventory-context-menu.component.scss',
})
export class SmItemContextMenuComponent extends InventoryContextMenuBase {
  readonly entityType = 'item' as const;
}
